import { offer as EnUsOffer } from '../en-us/offer';
import { AgResourceLanguage } from '../types';

export const offer: AgResourceLanguage['offer'] = {
  ...EnUsOffer,
  offerPrice: {
    firstTimePurchaseIncludes: 'Eerste aankoop bevat:',
    free: 'Gratis',
    total: 'Totaal',
    valueOfOneTimePurchase: 'Waarde bij eenmalige aankoop'
  }
};
